import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './Button.css'
export const Button = ({ status, type, text, icon, onClick, ariaLabel = "" }) => {
    return (
        <button
            className={`button-container ${status} ${type}`}
            onClick={onClick}
            aria-label={ariaLabel}
        >
            {text}
            {icon && <FontAwesomeIcon icon={icon} />}
        </button>
    );
}
